<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="mx-2"
        v-on="on"
      >
        <v-icon
          left
          small
        >
          mdi-cog
        </v-icon>
        <span class="caption">more options</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>File settings</v-card-title>
      <v-card-text class="pb-0">
        <v-container class="text-center pb-0">
          <v-row dense>
            <v-col
              v-if="type=='csv'"
              cols="12"
            >
              <v-select
                v-model="tempOptions.delimiter"
                label="Delimiter"
                :items="delimiterOptions"
                item-text="label"
                item-value="value"
                @input="v=> update('delimiter',v)"
              />
            </v-col>
            <v-col
              v-if="type=='csv'"
              cols="12"
            >
              <v-select
                v-model="tempOptions.encoding"
                label="Encoding"
                :items="encodingOptions"
                @input="v=> update('encoding',v)"
              />
            </v-col>
            <v-col
              v-if="type!='json'"
              cols="12"
            >
              <v-text-field
                v-model="tempOptions.header_index"
                label="Header is at index"
                value="0"
                clearable
                min="0"
                type="number"
                @input="v=> update('header_index',v)"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="tempOptions.limit"
                label="Limit rows count to"
                value="999"
                min="1"
                type="number"
                clearable
                @input="v=> update('limit',v)"
              />
            </v-col>
            <v-col
              v-if="type!='json'"
              cols="12"
            >
              <v-text-field
                v-model="tempOptions.offset"
                value="0"
                min="0"
                type="number"
                clearable
                label="Number of rows to skip (after header)"
                @input="v=> update('offset',v)"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="tempOptions.footer_index"
                type="number"
                min="1"
                clearable
                label="Footer starts at"
                @input="v=> update('footer_index',v)"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container class="py-0">
          <v-row class="py-0">
            <v-col class="text-center pt-0">
              <v-btn
                text
                @click="dialog = false"
              >
                Cancel
              </v-btn>
               <v-btn
                color="primary"
                class="mr-2"
                @click="submit"
              >
                Save
              </v-btn>
             
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ImportedFileOptionssBtn',
    props: {
      type: {
        type: String,
        default: null,
        required: true,
      },
      options: {
        required: true,
        type: Object,
        default: () => {
          return {
            header_index: 0,
            offset: 0,
            limit: null,
            footer_index: null,
            delimiter: null,
            encoding: null,
            sheet: null,
          }
        },
      },
    },
    data () {
      return {
        dialog: false,
        delimiterOptions: [
          { label: '; (semicolon)', value: ';' },
          { label: ', (comma)', value: ',' },
          { label: 'TAB', value: '\t' },
          { label: '# (hashtag)', value: '#' },
          { label: '^', value: '^' },
          { label: '|', value: '|' },
        ],
        encodingOptions: ['utf8', 'latin1', 'iso-8859-1', 'ascii', 'big5', 'gb2312', 'iso8859_2'],

        tempOptions: {
          header_index: 0,
          offset: 0,
          limit: null,
          footer_index: null,
          delimiter: null,
          encoding: null,
          sheet: null,
        },
      }
    },
    mounted () {
      const self = this
      Object.keys(self.options).map((key) => {
        self.tempOptions[key] = self.options[key]
      })
    },
    methods: {
      update (key, val) {
        this.$emit('update', key, val)
      },
      submit () {
        this.dialog = false
        this.$emit('submit')
      },
    },
  }
</script>
